import { useContext } from 'react';

import { CurrentBookingContext } from '../contexts/current-booking.context';

export function useCurrentBookingContext() {
  const context = useContext(CurrentBookingContext);

  if (!context) {
    throw new Error(
      'This component must be a child of <CurrentBookingProvider />'
    );
  }

  return context;
}
